import React from "react";

// Premium vector representation of Vedula Progress Hub branding
export const Logo = ({ className = "h-10 w-10", withText = true, tagline = true }) => {
  return (
    <div className="flex items-center gap-3 select-none">
      <svg
        viewBox="0 0 100 100"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="vph-brand-logo"
      >
        {/* Double Outer Rings */}
        <circle cx="50" cy="50" r="46" stroke="#0066FF" strokeWidth="2" />
        <circle cx="50" cy="50" r="42" stroke="#0066FF" strokeWidth="1" strokeDasharray="3 3" />
        
        {/* Swoosh Checkmark Vector */}
        <path
          d="M32 45C34 50 38 58 45 60C58 48 72 32 78 24"
          stroke="#0066FF"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Flying accents representing forward progress */}
        <path
          d="M52 48C56 46 62 44 68 45"
          stroke="#0066FF"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M50 56C55 54 60 53 66 55"
          stroke="#0066FF"
          strokeWidth="2.5"
          strokeLinecap="round"
        />

        {/* Open Book Icon at bottom center */}
        <path
          d="M36 78C40 76 45 76 50 78C55 76 60 76 64 78V68C60 67 55 67 50 69C45 67 40 67 36 68V78Z"
          fill="#0066FF"
          stroke="#0066FF"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M50 69V78"
          stroke="#FFFFFF"
          strokeWidth="1.5"
        />
      </svg>
      
      {withText && (
        <div className="flex flex-col items-start leading-none">
          <span 
            className="text-lg font-black tracking-tight text-inherit uppercase" 
            style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
            data-testid="logo-main-text"
          >
            Vedula
          </span>
          <span 
            className="text-xs font-bold uppercase tracking-widest text-[#0066FF]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            data-testid="logo-sub-text"
          >
            Progress Hub
          </span>
          {tagline && (
            <span className="text-[9px] text-muted-foreground italic font-medium mt-0.5">
              Serve. Grow. Forever Forward.
            </span>
          )}
        </div>
      )}
    </div>
  );
};

// Custom headshot display component using standard avatar image layout
export const MentorAvatar = ({ size = "lg", className = "" }) => {
  // Using the image uploaded by the user
  const headshotUrl = "https://images.unsplash.com/photo-1549692520-acc6669e2f0c?crop=entropy&cs=srgb&fm=jpg&q=85";
  const initials = "VR";

  return (
    <div className={`relative inline-block ${className}`}>
      <div className={`rounded-2xl overflow-hidden border-2 border-primary/20 bg-muted flex items-center justify-center shadow-lg transition-transform duration-300 hover:scale-105 ${
        size === "sm" ? "w-12 h-12" : size === "md" ? "w-24 h-24" : "w-48 h-48 md:w-56 md:h-56"
      }`}>
        <img
          src={headshotUrl}
          alt="Mr. Vedula - Senior Career Mentor"
          className="w-full h-full object-cover grayscale contrast-125 brightness-95 hover:grayscale-0 transition-all duration-500"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
          data-testid="mentor-avatar-img"
        />
        <div className="hidden absolute inset-0 items-center justify-center bg-primary text-primary-foreground font-black text-2xl">
          {initials}
        </div>
      </div>
      
      {/* Decorative tag */}
      <span className="absolute -bottom-2 -right-2 bg-amber-500 text-slate-950 text-[10px] font-black uppercase px-2 py-0.5 rounded shadow">
        Mentor
      </span>
    </div>
  );
};
